export enum EventTopic {
  ACCESS_TO_FINANCE = 'ACCESS_TO_FINANCE',
  ADMINISTRATIVE_BURDEN = 'ADMINISTRATIVE_BURDEN',
  BANKRUPTCY_AND_FRESH_START = 'BANKRUPTCY_AND_FRESH_START',
  BUSINESS_STRATEGY = 'BUSINESS_STRATEGY',
  BUSINESS_SUPPORT = 'BUSINESS_SUPPORT',
  CORPORATE_SOCIAL_RESPONSIBILITY = 'CORPORATE_SOCIAL_RESPONSIBILITY',
  ECOMMERCE = 'ECOMMERCE',
  ECONOMIC_SITUATION = 'ECONOMIC_SITUATION',
  ENTREPRENEURSHIP = 'ENTREPRENEURSHIP',
  ENTREPRENEURSHIP_EDUCATION = 'ENTREPRENEURSHIP_EDUCATION',
  ENVIRONMENT_OR_ENERGY_EFFICIENCY = 'ENVIRONMENT_OR_ENERGY_EFFICIENCY',
  ETHNIC_ENTREPRENEURSHIP = 'ETHNIC_ENTREPRENEURSHIP',
  FEMALE_ENTREPRENEURSHIP = 'FEMALE_ENTREPRENEURSHIP',
  FINANCE = 'FINANCE',
  GROWTH = 'GROWTH',
  INNOVATION_OR_TECHNOLOGY = 'INNOVATION_OR_TECHNOLOGY',
  INTELLECTUAL_PROPERTY_RIGHTS = 'INTELLECTUAL_PROPERTY_RIGHTS',
  INTERNAL_MARKET = 'INTERNAL_MARKET',
  INTERNATIONALISATION = 'INTERNATIONALISATION',
  MANAGEMENT = 'MANAGEMENT',
  MANAGEMENT_OF_EU_PROJECTS_FOR_SMES = 'MANAGEMENT_OF_EU_PROJECTS_FOR_SMES',
  MARKETING_OR_SALES = 'MARKETING_OR_SALES',
  NATIONAL_OR_REGIONAL_OR_LOCAL_INCENTIVES_FOR_SMES = 'NATIONAL_OR_REGIONAL_OR_LOCAL_INCENTIVES_FOR_SMES',
  NETWORKING_OR_COOPERATION = 'NETWORKING_OR_COOPERATION',
  PROMOTION_OF_EU_PROGRAMMES_FOR_SMES = 'PROMOTION_OF_EU_PROGRAMMES_FOR_SMES',
  PUBLIC_PROCUREMENT = 'PUBLIC_PROCUREMENT',
  SENIOR_ENTREPRENEURSHIP = 'SENIOR_ENTREPRENEURSHIP',
  SKILLS_OR_QUALIFICATIONS = 'SKILLS_OR_QUALIFICATIONS',
  SOCIAL_ENTREPRENEURSHIP = 'SOCIAL_ENTREPRENEURSHIP',
  STANDARISATION = 'STANDARISATION',
  STARTING_UP_A_BUSINESS = 'STARTING_UP_A_BUSINESS',
  SUBCONTRACTING = 'SUBCONTRACTING',
  TAX_AND_LEGAL_ISSUES = 'TAX_AND_LEGAL_ISSUES',
  TRANSFER_OF_BUSINESS = 'TRANSFER_OF_BUSINESS',
  YOUTH_ENTREPRENEURSHIP = 'YOUTH_ENTREPRENEURSHIP',
  OTHER = 'OTHER',
}
